import type { SVGProps } from 'react';
const SvgPivotTableChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pivot_table_chart_svg__a)">
      <path d="M10 8h11V5c0-1.1-.9-2-2-2h-9v5ZM3 8h5V3H5c-1.1 0-2 .9-2 2v3Zm2 13h3V10H3v9c0 1.1.9 2 2 2Zm8 1-4-4 4-4v8Zm1-9 4-4 4 4h-8ZM14.58 19H13v-2h1.58c1.33 0 2.42-1.08 2.42-2.42V13h2v1.58c0 2.44-1.98 4.42-4.42 4.42Z" />
    </g>
    <defs>
      <clipPath id="pivot_table_chart_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPivotTableChart;
